export const translations = {
  en: {
    languageLabel: "Language",
    main: {
      tagline: "See the eyes of your enemy",
      joinAlpha: "JOIN ALPHA",
      joinAlphaAria: "Scroll to Join Alpha section",
      gplayAria: "Download Urban Samurai on Google Play",
      appStoreAria: "Urban Samurai on the App Store (Coming Soon)",
      gplayAlt: "Get it on Google Play",
      appStoreAlt: "App Store",
      comingSoon: "COMING SOON",
      contact: "Contact",
      logoAlt: "Urban Samurai Logo",
      heroAlt: "Urban Samurai main art",
    },
    about: {
      title: "Card battler in Mixed Reality",
      text:
        "Create your own unique fighting style & challenge samurai like you are on the cyberpunk-streets of your home city.",
      imageAlt: "Game Screen",
    },
    characters: {
      title: "Choose your fighters",
      text: "Character bio coming soon",
    },
    fightingStyles: {
      title: "Choose your fighting styles",
      text: "Style details coming soon",
      names: {
        Karate: "Karate",
        Aikido: "Aikido",
        Kickboxing: "Kickboxing",
        Sambo: "Sambo",
        Kudo: "Kudo",
        Boxing: "Boxing",
        "Wing Chun": "Wing Chun",
        "Brazilian Jiu Jitsu": "Brazilian Jiu Jitsu",
        "Muay Thai": "Muay Thai",
        Shaolin: "Shaolin",
        "Krav Maga": "Krav Maga",
        Wrestling: "Wrestling",
      },
    },
    fightSystem: {
      slides: [
        {
          title: "Fighting system",
          subtitle: "Real-time card combat / skill-based simulation",
          text:
            "Customize your character with multiple body enhancements. Apply these techniques in a true fight simulation based on card battle-system of a new unique type.",
        },
        {
          title: "Choose your own battle style",
          subtitle: "Build your deck / define your martial identity",
          text:
            "Adapt your fighting style for abilities of your improved battle-cyborg body using different martial arts techniques from real world.",
        },
        {
          title: "Card battler in Mixed Reality",
          subtitle: "Real world map / cyberpunk encounters on the move",
          text:
            "Wander the paths of a real cyberpunk-future landscape in a skin of a street mercenary - a soldier of fortune of this brave new world, experiencing the unique mixture of life & game.",
        },
        {
          title: "Write your own story",
          subtitle: "Narrative campaign / choices and consequences",
          text:
            "Change the surrounding world with your own choices in the narrative campaign of the humankind's last stand against the unexpected side child of scientific evolution.",
        },
      ],
      videoTitle: "Urban Samurai gameplay",
      screen1Alt: "Game Screen 1",
      screen2Alt: "Game Screen 2",
      screen3Alt: "Game Screen 3",
    },
    storyVideo: {
      title: "Story & Narrative",
      playAria: "Play story video",
      iframeTitle: "Urban Samurai Story",
    },
    materials: {
      title: "Wallpapers",
      tabsAria: "Wallpapers tabs",
      desktop: "Desktop",
      phone: "Phone",
      openWallpaper: "Open wallpaper",
      pagination: "Pagination",
      previousPage: "Previous page",
      nextPage: "Next page",
      page: "Page",
      pages: "Pages",
      preview: "Wallpaper preview",
      closePreview: "Close preview",
      download: "Download",
      close: "Close",
      dimensionsLoading: "...",
    },
    devNews: {
      title: "Join Alpha Test",
      subtitle:
        "Welcome to the first playable Alpha. Access is limited and available only via our Google Group.",
      howToAccess: "How to get access",
      steps: [
        "Join the Google Group:",
        "Use the same Google account on your Android device / in Google Play.",
        "If the group is moderated, wait for approval.",
        "Follow the pinned installation instructions in the group.",
      ],
      importantTitle: "Important:",
      importantText:
        "Joined the group but still can't install? Google Play is probably using a different account. Switch accounts and try again.",
      cta: "Join Alpha Access (Google Group)",
      contactSupport: "Contact / support",
      warningTitle: "Alpha warning:",
      warningText: "crashes, wipes, balance issues - expected. Your feedback matters.",
      gplayAria: "Open Urban Samurai on Google Play",
      iosComingAria: "App Store coming soon",
      iosComingTitle: "iOS is coming later",
      logoAlt: "logo",
      appStoreAlt: "App Store (Coming soon)",
    },
  },
  ru: {
    languageLabel: "Язык",
    main: {
      tagline: "Посмотри в глаза своему противнику",
      joinAlpha: "Присоединиться к альфа тесту",
      joinAlphaAria: "Прокрутить к секции альфа-теста",
      gplayAria: "Скачать Urban Samurai в Google Play",
      appStoreAria: "Urban Samurai в App Store (скоро)",
      gplayAlt: "Доступно в Google Play",
      appStoreAlt: "App Store",
      comingSoon: "СКОРО",
      contact: "Контакт",
      logoAlt: "Логотип Urban Samurai",
      heroAlt: "Главный арт Urban Samurai",
    },
    about: {
      title: "Карточные бои в смешанной реальности",
      text:
        "Создай собственный уникальный стиль боя и брось вызов самураям так, будто ты уже вышел на киберпанк-улицы своего города.",
      imageAlt: "Игровой экран",
    },
    characters: {
      title: "Выбери своих бойцов",
      text: "Описание персонажа скоро появится",
    },
    fightingStyles: {
      title: "Выбери стили боя",
      text: "Описание стиля скоро появится",
      names: {
        Karate: "Каратэ",
        Aikido: "Айкидо",
        Kickboxing: "Кикбоксинг",
        Sambo: "Самбо",
        Kudo: "Кудо",
        Boxing: "Бокс",
        "Wing Chun": "Вин-чунь",
        "Brazilian Jiu Jitsu": "Бразильское джиу-джитсу",
        "Muay Thai": "Муай-тай",
        Shaolin: "Шаолинь",
        "Krav Maga": "Крав-мага",
        Wrestling: "Борьба",
      },
    },
    fightSystem: {
      slides: [
        {
          title: "Боевая система",
          subtitle: "Карточный бой в реальном времени / симуляция, завязанная на навыке",
          text:
            "Настраивай персонажа с помощью множества улучшений тела. Применяй эти техники в настоящей боевой симуляции, основанной на карточной боевой системе нового уникального типа.",
        },
        {
          title: "Выбери свой стиль боя",
          subtitle: "Собери колоду / определи свою боевую идентичность",
          text:
            "Адаптируй стиль боя под возможности улучшенного кибер-тела, используя техники разных боевых искусств из реального мира.",
        },
        {
          title: "Карточные бои в смешанной реальности",
          subtitle: "Реальная карта мира / киберпанк-схватки в движении",
          text:
            "Странствуй по улицам реального мира в образе наёмника киберпанк-будущего, ощущая уникальное смешение жизни и игры.",
        },
        {
          title: "Напиши свою историю",
          subtitle: "Сюжетная кампания / выбор и последствия",
          text:
            "Меняй окружающий мир собственными решениями в сюжетной кампании о последнем сопротивлении человечества против неожиданного побочного дитя научной эволюции.",
        },
      ],
      videoTitle: "Геймплей Urban Samurai",
      screen1Alt: "Игровой экран 1",
      screen2Alt: "Игровой экран 2",
      screen3Alt: "Игровой экран 3",
    },
    storyVideo: {
      title: "Сюжет и повествование",
      playAria: "Воспроизвести сюжетное видео",
      iframeTitle: "Сюжет Urban Samurai",
    },
    materials: {
      title: "Обои",
      tabsAria: "Вкладки с обоями",
      desktop: "Компьютер",
      phone: "Телефон",
      openWallpaper: "Открыть обои",
      pagination: "Пагинация",
      previousPage: "Предыдущая страница",
      nextPage: "Следующая страница",
      page: "Страница",
      pages: "Страницы",
      preview: "Предпросмотр обоев",
      closePreview: "Закрыть предпросмотр",
      download: "Скачать",
      close: "Закрыть",
      dimensionsLoading: "...",
    },
    devNews: {
      title: "Присоединяйся к альфа-тесту",
      subtitle:
        "Добро пожаловать в первую играбельную альфу. Доступ ограничен и выдаётся только через нашу Google Group.",
      howToAccess: "Как получить доступ",
      steps: [
        "Вступи в Google Group:",
        "Используй тот же Google-аккаунт на Android-устройстве и в Google Play.",
        "Если группа модерируется, дождись одобрения.",
        "Следуй закреплённой инструкции по установке внутри группы.",
      ],
      importantTitle: "Важно:",
      importantText:
        "Вступил в группу, но всё ещё не можешь установить игру? Скорее всего, Google Play использует другой аккаунт. Переключи аккаунт и попробуй снова.",
      cta: "Получить доступ к альфе (Google Group)",
      contactSupport: "Контакт / поддержка",
      warningTitle: "Предупреждение альфы:",
      warningText: "вылеты, вайпы, проблемы с балансом ожидаемы. Твой фидбек важен.",
      gplayAria: "Открыть Urban Samurai в Google Play",
      iosComingAria: "App Store скоро",
      iosComingTitle: "iOS появится позже",
      logoAlt: "логотип",
      appStoreAlt: "App Store (скоро)",
    },
  },
};
